import React, { Component } from 'react';
import moment from "moment";

// Componentes
import DateInput from "../common/date-input";

class ProblemsDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            date: moment(),
            comments: ''
        }
    }

    componentDidMount() {
        this.props.onRef(this);
    }
    componentWillUnmount() {
        this.props.onRef(undefined);
    }

    onSaveButtonClick = () => {
        this.props.onRegisterProblem({
            date: this.state.date,
            comments: this.state.comments
        });
        this.props.onCloseModal();
    };

    validateSubmit = () => {
        this.props.onCanSubmit(this.state.date.isValid() && this.state.comments !== '');
    };

    render() {
        return (
            <div>
                <div className="row modal-row">
                    <div className="col">
                        <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Proyecto</label>
                        <input
                            className="form-control"
                            type="text"
                            defaultValue={this.props.project.get('name')}
                            disabled={true}
                        />
                    </div>
                    <div className="col">
                        <div className="form-group">
                            <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Fecha</label>
                            <DateInput
                                onChange={(selectedValue) => this.setState({
                                    date: selectedValue
                                }, this.validateSubmit)}
                                value={this.state.date}
                                inputWrapperStyle={{height: 40}}
                                inputStyle={{height: 37, borderRadius: 0, border: '1px solid #ccc'}}
                                iconStyle={{top: 9, right: 12}}
                            />
                        </div>
                    </div>
                </div>
                <div className="row modal-row">
                    <div className="col">
                        <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Comentarios incidencia</label>
                        <input
                            className="form-control"
                            type="text"
                            value={this.state.comments}
                            onChange={ (event) => this.setState({ comments: event.target.value}, this.validateSubmit) }
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default ProblemsDialog;


// WEBPACK FOOTER //
// ./src/components/dialogs/ProblemsDialog.js